import { connect } from '@atlassian/jira-react-redux';
import type { ReportKey } from '../../../model/types';
import { getReportByKey } from '../../../state/selectors/reports';
import type { State } from '../../../state/types';
import Item, { type Props } from './view';

type OwnProps = {
	reportKey: ReportKey;
};

export const mapStateToProps = (state: State, ownProps: OwnProps): Props =>
	// @ts-expect-error - TS2322 - Type 'Report | undefined' is not assignable to type 'Props'.
	getReportByKey(state, ownProps.reportKey);

export default connect(mapStateToProps, {})(Item);
